export const EXERCISE_CHANGED = 'EXERCISE_CHANGED'
export const exerciseChanged = () => ({
    type: EXERCISE_CHANGED,
    payload: {},
})
